import { createPinia } from 'pinia'
export { useUserStore } from './user'

const store = createPinia()

export default store